var map = {
	"./bg-cardNpc.webp": 9760,
	"./bg-caves.webp": 153,
	"./bg-desert.webp": 9050,
	"./bg-forest.webp": 6604,
	"./bg-hell.webp": 5325,
	"./bg-mountain.webp": 7315,
	"./bg-sea.webp": 7723,
	"./bg-zone.webp": 3112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5503;